import React from 'react'

import { flag } from '@ui-kit/components/Flag/styles'
import { bgColor, textColor } from '@ui-kit/styles/colors'
import type { Color } from '@ui-kit/types'

import type { Props } from './types'

const Flag = (props: Props): JSX.Element => {
  const getTextColor = (color: Color): Color => (color.endsWith('Light') ? 'uiDark' : 'uiLight')

  const { container, box, text } = flag({ position: props.position })

  return (
    <div className={container()}>
      <div className={box({ className: bgColor({ color: props.backgroundColor ?? 'brandDark' }) })}>
        <p
          className={text({
            className: props.backgroundColor
              ? textColor({ color: getTextColor(props.backgroundColor) })
              : '',
          })}
        >
          {props.text}
        </p>
      </div>
    </div>
  )
}

export default Flag
